import type { PropsWithChildren } from 'react';
import type React from 'react';

import {
	useVideoContextValue,
	useVideosComponentContextValue,
	VideoContextProviderInternal,
	VideosComponentContextProviderInternal,
} from './context';

export const VideoContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const { value } = useVideoContextValue();

	return <VideoContextProviderInternal value={value}>{children}</VideoContextProviderInternal>;
};

export const VideosComponentContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const { value } = useVideosComponentContextValue();

	return <VideosComponentContextProviderInternal value={value}>{children}</VideosComponentContextProviderInternal>;
};
